import { useTranslation } from 'react-i18next';

import { ApplicationInsightsTrackerException } from 'library/components/track/ApplicationInsightsTrackerException';

import { ErrorDetails } from './ErrorDetails';
import { ErrorFallbackProps } from './ErrorFallback';

export const ErrorComponentFallback = (props: ErrorFallbackProps) => {
	const { t } = useTranslation(['error', 'home']);

	return (
		<ErrorDetails
			description={t('error:contact-support')}
			subtitle={t('error:application-crash')}
			title={t('error:unauthenticated-title')}>
			<ApplicationInsightsTrackerException
				metric={{ exception: props.error }}
			/>
		</ErrorDetails>
	);
};
